var _path, _path2, _ellipse;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRadioShazam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7853 12.4063C19.393 8.87716 19.3901 3.73755 15.7853 0.211226C15.5169 -0.0513296 15.0337 -0.0719805 14.7324 0.16524L14.3846 0.439132C14.111 0.654568 14.086 1.00737 14.3288 1.24641C17.3094 4.18089 17.307 8.43909 14.3288 11.3712C14.086 11.6102 14.111 11.963 14.3846 12.1784L14.7324 12.4523C15.0337 12.6895 15.5169 12.6689 15.7853 12.4063ZM13.0275 10.1913C15.1901 7.90821 15.1936 4.71305 13.0275 2.42626C12.7642 2.14823 12.2659 2.11816 11.9564 2.36199L11.6074 2.63696C11.3434 2.8449 11.3076 3.18381 11.5303 3.42216C13.1221 5.12574 13.122 7.49193 11.5303 9.19541C11.3076 9.43376 11.3434 9.77261 11.6074 9.98061L11.9564 10.2556C12.2659 10.4994 12.7642 10.4693 13.0275 10.1913Z",
    fill: "#0BD6A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.70468 0.21121C-0.903003 3.7404 -0.900124 8.88 2.70468 12.4063C2.97307 12.6689 3.45634 12.6895 3.7576 12.4523L4.10541 12.1784C4.37895 11.963 4.40397 11.6102 4.1612 11.3711C1.18056 8.43666 1.18302 4.17846 4.1612 1.2464C4.40397 1.00735 4.37901 0.654552 4.10541 0.439116L3.7576 0.165225C3.45634 -0.0719958 2.97307 -0.0513444 2.70468 0.21121ZM5.46246 2.42624C3.29989 4.70934 3.29641 7.9045 5.46246 10.1913C5.72581 10.4693 6.22413 10.4994 6.53361 10.2556L6.88262 9.98059C7.14656 9.77265 7.18244 9.43375 6.9597 9.19539C5.36786 7.49182 5.36798 5.12562 6.9597 3.42215C7.18244 3.18379 7.14656 2.84494 6.88262 2.63695L6.53361 2.36197C6.22413 2.11815 5.72581 2.14821 5.46246 2.42624Z",
    fill: "#0BD6A7"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.24941,
    cy: 6.40368,
    rx: 1.66015,
    ry: 1.66021,
    fill: "#0BD6A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioShazam);
export default __webpack_public_path__ + "static/media/radio-shazam.2e30d85d.svg";
export { ForwardRef as ReactComponent };